import { render } from "./TermsOfService.vue?vue&type=template&id=37e425f3&scoped=true"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"

import "./TermsOfService.vue?vue&type=style&index=0&id=37e425f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e425f3"]])

export default __exports__